import React from "react";
import "../App.css";

export function SatelliteLogo({ size = 56 }: { size?: number }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 120 120"
            className="sat-logo"
            role="img"
            aria-label="TV Guide"
        >
            <defs>
                <linearGradient id="screenGrad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#3ddbd9" />
                    <stop offset="50%" stopColor="#48b1f0" />
                    <stop offset="100%" stopColor="#7c3aed" />
                </linearGradient>
                <linearGradient id="frameGrad" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#48b1f0" />
                    <stop offset="100%" stopColor="#7c3aed" />
                </linearGradient>
                <linearGradient id="standGrad" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#3ddbd9" />
                    <stop offset="100%" stopColor="#48b1f0" />
                </linearGradient>
            </defs>

            {/* TV frame */}
            <rect
                x="14" y="10" width="92" height="68" rx="8"
                fill="none"
                stroke="url(#frameGrad)"
                strokeWidth="3"
            />
            {/* Inner screen */}
            <rect
                x="20" y="16" width="80" height="56" rx="4"
                fill="none"
                stroke="url(#screenGrad)"
                strokeWidth="1.5"
                opacity="0.4"
            />

            {/* Antenna left */}
            <g className="tv-antenna-left">
                <line x1="44" y1="10" x2="28" y2="-4" stroke="url(#frameGrad)" strokeWidth="2.5" strokeLinecap="round" />
                <circle cx="28" cy="-4" r="3" fill="url(#screenGrad)" />
            </g>
            {/* Antenna right */}
            <g className="tv-antenna-right">
                <line x1="76" y1="10" x2="92" y2="-4" stroke="url(#frameGrad)" strokeWidth="2.5" strokeLinecap="round" />
                <circle cx="92" cy="-4" r="3" fill="url(#screenGrad)" />
            </g>

            {/* Signal waves from antennas */}
            <g className="tv-signal-left">
                <circle cx="28" cy="-4" r="6" fill="none" stroke="#3ddbd9" strokeWidth="1.2" opacity="0.6" />
                <circle cx="28" cy="-4" r="11" fill="none" stroke="#3ddbd9" strokeWidth="1" opacity="0.3" />
            </g>
            <g className="tv-signal-right">
                <circle cx="92" cy="-4" r="6" fill="none" stroke="#48b1f0" strokeWidth="1.2" opacity="0.6" />
                <circle cx="92" cy="-4" r="11" fill="none" stroke="#48b1f0" strokeWidth="1" opacity="0.3" />
            </g>

            {/* Screen content — animated scan lines */}
            <g className="tv-screen-content" clipPath="inset(0 0 0 0)">
                <rect x="20" y="16" width="80" height="56" rx="4" fill="url(#screenGrad)" opacity="0.08" />
                <rect x="20" y="16" width="80" height="56" rx="4" fill="url(#screenGrad)" opacity="0.08" />
                {/* Scanning line */}
                <rect className="tv-scanline" x="22" y="18" width="76" height="2" fill="#3ddbd9" opacity="0.6" rx="1" />
                {/* Channel bars */}
                <rect className="tv-bar tv-bar-1" x="26" y="56" width="6" height="12" rx="1" fill="#3ddbd9" opacity="0.7" />
                <rect className="tv-bar tv-bar-2" x="36" y="52" width="6" height="16" rx="1" fill="#48b1f0" opacity="0.7" />
                <rect className="tv-bar tv-bar-3" x="46" y="48" width="6" height="20" rx="1" fill="#3ddbd9" opacity="0.7" />
                <rect className="tv-bar tv-bar-4" x="56" y="54" width="6" height="14" rx="1" fill="#7c3aed" opacity="0.7" />
                <rect className="tv-bar tv-bar-5" x="66" y="50" width="6" height="18" rx="1" fill="#48b1f0" opacity="0.7" />
                <rect className="tv-bar tv-bar-6" x="76" y="46" width="6" height="22" rx="1" fill="#3ddbd9" opacity="0.7" />
                <rect className="tv-bar tv-bar-7" x="86" y="52" width="6" height="16" rx="1" fill="#7c3aed" opacity="0.7" />
            </g>

            {/* Stand neck */}
            <rect x="54" y="78" width="12" height="8" rx="2" fill="url(#standGrad)" opacity="0.7" />
            {/* Stand base */}
            <path d="M 36 100 Q 60 86 84 100" fill="none" stroke="url(#standGrad)" strokeWidth="3" strokeLinecap="round" />
            <rect x="36" y="98" width="48" height="4" rx="2" fill="url(#standGrad)" opacity="0.4" />
        </svg>
    );
}
